import { useCallback, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { discoveryQueryKeys } from '@/entities/discovery';
import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';
import { useDiscoveryStore } from '../stores/discovery-store';

type UseStopDiscoverySearchParams = {
  sessionId: string;
  searchId?: string | null;
};

export function useStopDiscoverySearch({ sessionId, searchId }: UseStopDiscoverySearchParams) {
  const queryClient = useQueryClient();
  const { workspaceId } = useWorkspaceId();
  const { setIsSearching } = useDiscoveryStore();
  const [stoppedSearchKey, setStoppedSearchKey] = useState<string | null>(null);

  const searchKey = searchId ? `${sessionId}:${searchId}` : null;
  const isStopped = searchKey != null && stoppedSearchKey === searchKey;

  const stopSearch = useCallback(() => {
    if (!searchId || !searchKey) return;

    setStoppedSearchKey(searchKey);
    setIsSearching(false);

    void queryClient.cancelQueries({
      queryKey: discoveryQueryKeys.searchStatus(workspaceId, sessionId, searchId),
    });
  }, [queryClient, searchId, searchKey, sessionId, setIsSearching, workspaceId]);

  return {
    isStopped,
    stopSearch,
  };
}
